import { FaWhatsapp } from "react-icons/fa";

const TravelEnquiryPage = ({
  eyebrow,
  title,
  description,
  image,
  imageAlt,
  highlights,
  enquiryMessage,
}) => {
  const enquiryText = encodeURIComponent(`Hi, I would like to enquire about ${title}.`);
  const whatsappUrl = `https://wa.me/919371939191?text=${enquiryText}`;

  return (
    <main className="bg-gradient-to-b from-amber-50 via-orange-50 to-white px-4 py-10 sm:px-6 sm:py-14">
      <div className="mx-auto max-w-6xl overflow-hidden rounded-3xl bg-white shadow-xl ring-1 ring-amber-900/10">
        <div className="grid md:grid-cols-2">
          <div className="relative min-h-64 md:min-h-[32rem]">
            <img
              src={image}
              alt={imageAlt}
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-950/50 via-transparent to-transparent" />
          </div>
          <div className="flex flex-col items-start justify-center p-6 sm:p-9 lg:p-12">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-blue-800">
              {eyebrow}
            </p>
            <h1 className="mt-3 text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl">
              {title}
            </h1>
            <p className="mt-4 text-base leading-7 text-stone-600">
              {description}
            </p>

            <ul className="mt-6 space-y-3">
              {highlights.map((highlight) => (
                <li
                  key={highlight}
                  className="flex items-start gap-3 text-sm leading-6 text-stone-700 sm:text-base"
                >
                  <span
                    aria-hidden="true"
                    className="mt-2 h-2 w-2 shrink-0 rounded-full bg-amber-500"
                  />
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Enquire about ${title} on WhatsApp`}
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-blue-800 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
            >
              <FaWhatsapp aria-hidden="true" className="h-5 w-5" />
              {enquiryMessage}
            </a>
            <p className="mt-3 text-xs leading-5 text-stone-500">
              Share your preferred dates and group size so our team can help
              with the next steps.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TravelEnquiryPage;
